var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EDD100",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8469 16.9801L20.3469 11.9801C20.2442 11.9116 20.1235 11.875 20 11.875C19.8765 11.875 19.7558 11.9116 19.6531 11.9801L12.1531 16.9801C12.0675 17.0372 11.9973 17.1146 11.9488 17.2054C11.9003 17.2961 11.8749 17.3975 11.875 17.5004V25.6254C11.875 25.9569 12.0067 26.2749 12.2411 26.5093C12.4755 26.7437 12.7935 26.8754 13.125 26.8754H26.875C27.2065 26.8754 27.5245 26.7437 27.7589 26.5093C27.9933 26.2749 28.125 25.9569 28.125 25.6254V17.5004C28.1251 17.3975 28.0997 17.2961 28.0512 17.2054C28.0027 17.1146 27.9325 17.0372 27.8469 16.9801ZM17.5563 21.8754L13.125 25.0004V18.7137L17.5563 21.8754ZM18.8352 22.5004H21.1648L25.5891 25.6254H14.4109L18.8352 22.5004ZM22.4438 21.8754L26.875 18.7137V25.0004L22.4438 21.8754ZM20 13.2512L26.3992 17.5176L21.1648 21.2504H18.8367L13.6023 17.5176L20 13.2512Z",
    fill: "#EDD100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage1);
export default __webpack_public_path__ + "static/media/message1.1053d100b91f60f2eaeec8a5b8f5bad9.svg";
export { ForwardRef as ReactComponent };